// icons
import { 
  MdGroups, 
  //MdPeople, 
  MdCalendarToday, 
  MdPersonSearch, 
  MdChat,
  MdAutorenew
} from "react-icons/md";

const crm = {
    id: 'crm-group',
    type: 'group',
    roles: [1,100,110,400,500],
    breadcrumbs: false,
    children: [
      {
        id: 'crm',
        title: "CRM",
        type: 'collapse',
        icon: MdGroups,
        children: [
          {
            id: 'prospectos',
            title: "Prospectos",
            type: 'item',
            breadcrumbs: false,
            icon: MdPersonSearch,
            roles: [1,100,110,400,500],
            url: '/crm/prospectos'
          },
          {
            id: 'crm-clientes',
            title: "Clientes",
            type: 'item',
            breadcrumbs: false,
            icon: MdGroups,
            roles: [1,100,110,400,500],
            url: '/crm/clientes'
          },
          {
            id: 'interacciones',
            title: "Interacciones",
            type: 'item',
            breadcrumbs: false,
            icon: MdChat,
            roles: [1,400,500],
            url: '/crm/interacciones'
          },
          {
            id: 'agenda',
            title: "Agenda",
            type: 'item',
            breadcrumbs: false,
            icon: MdCalendarToday,
            roles: [400,500],
            url: '/crm/agenda'
          },
          {
            id: 'crm-citas-automatizadas',
            title: 'Citas automatizadas',
            type: 'item',
            breadcrumbs: false,
            icon: MdAutorenew,
            roles: [400,500],
            url: '/crm/citas-automatizadas'
          },
          
        ]
      }
    ]
  };

export default crm;
